import constants, { ACCESS_TOKEN, default_size, HTTP_METHODS } from "../../../settings/shared/constants"
import axiosClient from "../../common"

function _constructHeader() {
    let jwtToken = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + jwtToken
    }
    return headers;
}

function getcloudList(page = 0, size = default_size) {
    return axiosClient({
        url: `${constants.api.cloud.get_cloud}?page=${page}&size=${size}`,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
        data: ''
    })
}

function createcloud(data) {
    return axiosClient({
        url: constants.api.cloud.create_cloud,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: data
    })
}

function deletecloud(id) {
    return axiosClient({
        url: constants.api.cloud.delete_cloud + "/" + id,
        method: HTTP_METHODS.DELETE,
        headers: _constructHeader(),
        data: ''
    })
}

//To export run function
const CloudService = {
    getcloudList, createcloud, deletecloud
}
export default CloudService;
